export default __webpack_public_path__ + "static/media/call.833d2227.svg";